//function tabCarouselInit() {
//    ($('.product-tabs') as any).owlCarousel({
//        rtl: true,
//        autoWidth: true,
//        dots: false
//    });
//}

function tabClickHandler() {
    const selector = '.product-tabs a';
    $(selector).off('click');
    $(selector).on('click' , function() {
        $('.product-tabs a').removeClass('selected');
        $(this).addClass('selected');
        showSelectedTab();
    });
}

function showSelectedTab() {
    $('.product-tab-body > div').hide();
    $('#' + $('.product-tabs a.selected').data('tab-id')).show();
}


const initTabs = () => {
    tabClickHandler();
    showSelectedTab();
};

export {
    initTabs
};
